module.exports = __webpack_public_path__ + "static/img/_DSC1349.4f43827.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio5/_DSC1349.jpg
// module id = xvKd
// module chunks = 0